"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteStyleSection = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var StyleShortCutContainer_1 = __importDefault(require("Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var mobx_1 = require("mobx");
var ColorUtils_1 = require("Common/Utils/ColorUtils/ColorUtils");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var QuoteStyleSection = (function (_super) {
    __extends(QuoteStyleSection, _super);
    function QuoteStyleSection() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleSectionStyleChange = function (withQuoteBackground) {
            var _a = _this.props, filteredColors = _a.filteredColors, blockStyleStore = _a.blockStore.blockStyleStore;
            var headerSectionStyle = __assign({}, blockStyleStore.model.headerSection);
            headerSectionStyle.on = withQuoteBackground;
            blockStyleStore.setStylePropsByKey("quoteBackgroundOn", withQuoteBackground);
            blockStyleStore.setStylePropsByKey("headerSection", headerSectionStyle);
            _this.trackChange({
                block_styles_contextual_quote_section_card: withQuoteBackground ? "true" : "false",
            });
            if (withQuoteBackground && blockStyleStore.model.uiHighlightColor.themeIndex === DefaultColors_1.DEFAULT_WHITE.themeIndex) {
                var newUiHighlightColor = {
                    themeIndex: _this.colorsExcludingWhite[0].themeIndex,
                    abs: _this.colorsExcludingWhite[0].value,
                };
                blockStyleStore.setStylePropsByKey("uiHighlightColor", newUiHighlightColor);
            }
            else if (!withQuoteBackground && !_this.isColorValid(filteredColors, blockStyleStore.model.uiHighlightColor)) {
                var newUiHighlightColor = {
                    themeIndex: filteredColors[0].themeIndex,
                    abs: filteredColors[0].value,
                };
                blockStyleStore.setStylePropsByKey("uiHighlightColor", newUiHighlightColor);
            }
        };
        _this.isColorValid = function (colors, targetColor) {
            return colors.find(function (color) { return color.themeIndex === targetColor.themeIndex; });
        };
        _this.trackChange = function (parameters) {
            return _this.props.telemetry.trackOnly("Block Styles Contextual Changed", parameters, {
                blockIntercom: true,
            });
        };
        _this.handleHighlightColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var uiHighlightColor = __assign({}, blockStyleStore.model.uiHighlightColor);
            uiHighlightColor.abs = color.value;
            uiHighlightColor.themeIndex = color.themeIndex;
            blockStyleStore.setStylePropsByKey("uiHighlightColor", uiHighlightColor);
            _this.trackChange({
                block_styles_contextual_quote_highlight_color: (0, ColorUtils_1.getTelemetryColor)(color),
            });
        };
        _this.handleHeaderSectionColorChange = function (color) {
            var blockStyleStore = _this.props.blockStore.blockStyleStore;
            var headerSection = __assign({}, blockStyleStore.model.headerSection);
            headerSection.color.abs = color.value;
            headerSection.color.themeIndex = color.themeIndex;
            blockStyleStore.setStylePropsByKey("headerSection", headerSection);
            _this.trackChange({
                block_styles_contextual_quote_section_card_color: (0, ColorUtils_1.getTelemetryColor)(color),
            });
        };
        return _this;
    }
    Object.defineProperty(QuoteStyleSection.prototype, "sectionStylesOptions", {
        get: function () {
            return [
                {
                    label: "Visual",
                    value: true,
                },
                {
                    label: "Simple",
                    value: false,
                },
            ];
        },
        enumerable: false,
        configurable: true
    });
    QuoteStyleSection.prototype.render = function () {
        var _a = this.props, blockStyleStore = _a.blockStore.blockStyleStore, filteredColors = _a.filteredColors;
        var _b = blockStyleStore.model, headerSection = _b.headerSection, uiHighlightColor = _b.uiHighlightColor, quoteBackgroundOn = _b.quoteBackgroundOn;
        var filteredColorsIncludingSilver = this.filteredColorsIncludingSilver;
        return (react_1.default.createElement(StyleShortCutContainer_1.default, { dark: true },
            react_1.default.createElement("div", { className: "style-shortcut__main quote-style-shortcut" },
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                        react_1.default.createElement(kaleidoscope_1.SegmentedControl, { theme: kaleidoscope_1.SegmentedControlTheme.Dark, label: "section style", size: kaleidoscope_1.SegmentedControlSize.Medium, options: this.sectionStylesOptions, selectedValue: quoteBackgroundOn, onClickHandler: this.handleSectionStyleChange }))),
                quoteBackgroundOn && (react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "primary color"),
                    react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                        react_1.default.createElement(ColorPalette_1.default, { onColorChange: this.handleHeaderSectionColorChange, presetColors: filteredColorsIncludingSilver, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(headerSection.color), filteredColorsIncludingSilver), type: "content" })))),
                react_1.default.createElement("div", { className: "style-shortcut__section" },
                    react_1.default.createElement("div", { className: "style-shortcut__section-title label" }, "highlight color"),
                    react_1.default.createElement("div", { className: "style-shortcut__buttons-container" },
                        react_1.default.createElement(ColorPalette_1.default, { key: uiHighlightColor.abs, onColorChange: this.handleHighlightColorChange, presetColors: quoteBackgroundOn ? this.colorsExcludingWhite : filteredColors, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(uiHighlightColor), quoteBackgroundOn ? this.colorsExcludingWhite : filteredColors), type: "content" }))))));
    };
    Object.defineProperty(QuoteStyleSection.prototype, "colorsExcludingWhite", {
        get: function () {
            return this.props.brandStore.colorsWithThemeIndex.filter(function (color) {
                if (color.themeIndex == undefined) {
                    return false;
                }
                else {
                    return ![DefaultColors_1.DEFAULT_GREY10.themeIndex, DefaultColors_1.DEFAULT_WHITE.themeIndex].includes(color.themeIndex);
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteStyleSection.prototype, "filteredColorsIncludingSilver", {
        get: function () {
            return __spreadArray(__spreadArray(__spreadArray([], __read(this.props.filteredColors.filter(function (color) { return color.themeIndex !== DefaultColors_1.DEFAULT_WHITE.themeIndex; })), false), [
                DefaultColors_1.DEFAULT_GREY25
            ], false), __read(this.props.filteredColors.filter(function (color) { return color.themeIndex === DefaultColors_1.DEFAULT_WHITE.themeIndex; })), false);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], QuoteStyleSection.prototype, "handleSectionStyleChange", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QuoteStyleSection.prototype, "colorsExcludingWhite", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], QuoteStyleSection.prototype, "filteredColorsIncludingSilver", null);
    QuoteStyleSection = __decorate([
        mobx_react_1.observer
    ], QuoteStyleSection);
    return QuoteStyleSection;
}(react_1.default.Component));
exports.QuoteStyleSection = QuoteStyleSection;
exports.default = (0, WithColorFilterSubscription_1.default)(QuoteStyleSection);
